
import { formatCurrencyByProject } from '@t/format-currency';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ProfileItem extends Vue {
    @Prop({ required: true }) currentProfile!: any;
    @Prop({ required: true }) selectedPlanificationPhaseToUpdate!: any;
    @Prop({ required: true }) profileIndex!: number;
    @Prop({ required: true }) showValidation!: boolean;
    @Prop({ required: true }) validationObject!: any;

    get validationStyle() {
        return {
            display:
                this.showValidation === true &&
                this.validationObject.length > this.profileIndex &&
                (this.validationObject[this.profileIndex].profil === true ||
                    this.validationObject[this.profileIndex].studio === true)
                    ? 'inline'
                    : 'none'
        };
    }

    // warning : Code dupliqué,
    formatAmountWithCurrency(value: number): string {
        return formatCurrencyByProject(value, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
}
